import type { BorderTheme } from "../../semantic/borders";

export const baseBorders: BorderTheme = {
  width: {
    none: 0,
    thin: 1,
    medium: 2,
    thick: 4,
  },
};
